module.exports = __webpack_public_path__ + "img/14.20cda23b.jpg";